import React, {useState} from 'react';
import useTranslation from '../../../i18n/useTranslation';
import ServicesFilter from '../Filters/services'
import ClassYearFilter from '../Filters/ClassYear'
import CountryFilter from '../Filters/Countries'
import StatusFilter from '../Filters/Status'
import TestDateFilter from '../Filters/testdata'
import TopicsFilter from '../Filters/topics'
import TagsFilter from '../../Payments/Filters/Tags'
import ResetFiltersButton from '../../../common/ResetFiltersButton'
// import { useSelector } from 'react-redux';
// import _ from 'lodash'

//retorna el html con los filtros especificos para cada sección (student, educators, staffs y parents)
//STUDENT EDUCATOR STAFF PARENT
const STUDENT = 'STUDENT'
const EDUCATOR = 'EDUCATOR'
// eslint-disable-next-line
const STAFF = 'SUPER_ADMIN'
const PARENT = 'PARENT'
const RenderFilters = (props) => {
    const {role = STUDENT, setQuery = () => {}, query = {}, canReset = false, onReset = () => {}, ...otherProps} = props
    const {translate} = useTranslation()
    // const services = useSelector((state) => state.user.services)

    // const getServiceById = (serviceId) => {
    //   return !_.isEmpty(services)
    //     ? services.find((service) => service.id === serviceId)
    //     : null
    // }
  const [namesDataFilters, setNamesDataFilters] = useState([])
    return (
        <>
            <div className='container-fluid mt-2 mt-md-5 d-flex px-0 mb-3 znk-scroll-horizontal' {...otherProps}>
            {
                [STUDENT, EDUCATOR, PARENT, STAFF].includes(role) && (
                  <StatusFilter statusFilters={ ![undefined, null].includes(query?.statuses) ? [query?.statuses ? '1' : '0'] : ['1', '0']} 
                    setStatusFilters={(status) => {
                      const allSelected = (status.includes('1') && status.includes('0')) || status.length === 0 || !status
                      const newStatus = allSelected ? undefined /**Muestra activos e inactivos**/ : status.includes('1')
                      setQuery({...query, statuses: newStatus})
                    }} />
                )
              }
              {
                [STUDENT, EDUCATOR].includes(role) && (
                  <>
                  <ServicesFilter 
                    servicesFilters={query?.serviceIds} 
                    setServicesFilters={(services) => {
                      setQuery({ ...query, serviceIds: services })
                    }} 
                  />
                    {
                      query?.serviceIds?.length ? 
                        <TopicsFilter 
                          {...{ 
                            topicFilters: query?.topicIds, 
                            setTopicFilters: (ids) => {setQuery({...query, topicIds: ids})}, 
                            serviceFilters: query?.serviceIds
                          }}  
                        /> : null
                    } 
                  </>   
                )
              }
              {
                [EDUCATOR].includes(role) && (
                  <>
                  <ServicesFilter
                    title={translate('filters.educators.otherservices.title')}
                    servicesFilters={query?.otherServiceIds} 
                    setServicesFilters={(services) => {
                      setQuery({ ...query, otherServiceIds: services })
                    }} 
                    />
                  {
                      query?.otherServiceIds?.length ? 
                        <TopicsFilter 
                          {...{ 
                            title:translate('filters.educators.otherstopics.title'),
                            topicFilters: query?.otherTopicIds, 
                            setTopicFilters: (ids) => {setQuery({...query, otherTopicIds: ids})}, 
                            serviceFilters: query?.otherServiceIds
                          }}  
                        /> : null
                    } 
                    </>
                )
              }
              {
                [STUDENT].includes(role) && (
                  <TestDateFilter {...{ 
                    testDate: query?.testDate || [],
                    setTestDate: (testDates) => {
                      setQuery({...query, testDate: testDates})
                    },
                    servicesFilters: query?.serviceIds
                  }} />
                )
              }
              
              {
                [STUDENT].includes(role) && (
                  <ClassYearFilter 
                    classFilters={query?.classYear} 
                    setClassFilters={(newClassYear) => {setQuery({...query, classYear: newClassYear})}} />
                )
              }

              {
                [STUDENT].includes(role) && (
                <TagsFilter {...{
                  tagsFilters: query?.tags || [],
                  setTagsFilters: (tags) => {
                    setQuery({ ...query, tags })
                  }
                }} />
                )
              }

              {
                [STUDENT, PARENT].includes(role) && (
                  <CountryFilter 
                    countryFilters={query?.countriesIds} 
                    setCountryFilters={(newCountries) => {setQuery({...query, countriesIds: newCountries})}} 
                    setNamesDataFilters={setNamesDataFilters} 
                    namesDataFilters={namesDataFilters} 
                  /> 
                )
              }
              {
                canReset
                ? <ResetFiltersButton onClick={onReset} />
                  : null
              }
            </div>
        </>
    )
}

export default RenderFilters
